import { AppHeader } from '@cub-com-br/theme/app-header';
import { FC } from 'react';
import { useTenant } from '~/hooks/use-branding';

export const Header: FC<Props> = ({ logout, showExitIdentityCheckFlowButton }) => {
  const { tenant, companyName, companyLogoUrl } = useTenant();

  const exitIdentityCheckFlow = () => (window.location.href = '/');

  return (
    <AppHeader
      // Magic link shares the statement viewer's header
      app="statement-viewer"
      tenant={tenant}
      companyName={companyName}
      companyLogoSrc={companyLogoUrl}
      onBack={showExitIdentityCheckFlowButton ? exitIdentityCheckFlow : logout}
      backLabel={showExitIdentityCheckFlowButton ? 'Cancelar validação' : 'Sair'}
    />
  );
};

interface Props {
  logout?: () => void;
  showExitIdentityCheckFlowButton?: boolean;
}
